export default __webpack_public_path__ + "特征分类.jpg";